import { RpcService } from 'rpc';
export const svc = new RpcService({
    transport: 'WEBSOCKET',
    envelope: 'JSON-RPC-2.0',
    strictParameters: false,
    target: `${window.hcstatic.portal_url}/@@learningpath.rpc`,
    services: {
        keyword_search: {
            parameters: [
                {
                    name: 'find',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        topics_for_keyword: {
            parameters: [
                {
                    name: 'keyword',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        },
        related_topics: {
            parameters: [
                {
                    name: 'topicid',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'version',
                    type: 'string',
                    optional: false
                },
                {
                    name: 'language',
                    type: 'string',
                    optional: false
                }
            ]
        }
    }
});
export default svc;
